import { QueryClient, QueryCache } from '@tanstack/react-query';
import { useGlobalAlertStore } from '@/store/globalAlert';

// React Query 클라이언트 생성
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 0, // 기본적으로 즉시 서버에 재요청 (캐싱 방지)
    },
  },
  queryCache: new QueryCache({
    onError: error => {
      // 전역 에러 핸들링: 삭제된 페이지(게시물) 판별
      if (error.message === '값을 불러오는데 실패하였습니다.') {
        useGlobalAlertStore.getState().openAlert('삭제된 페이지입니다.', true);
      }
      if (error.message === '상품을 찾을 수 없습니다.') {
        useGlobalAlertStore.getState().openAlert('삭제된 상품입니다.', true);
      }
    },
  }),
});
